import React from 'react';
import classnames from 'classnames';
import PlatformIcon from '@gp/components/PlatformIcon';
import StrategicImageNew from '@sg/components/StrategicImageNew';
import TextBubbles from '@/pages/home/components/TextBubbles';

import './index.scss';

interface IProjectInfoProps {
  className?: string;
  style?: React.CSSProperties;
  // 项目名称
  name?: string;
  // 项目描述
  des?: string;
  // 项目封面图
  src?: string;
  // 封面图宽高（正方形）
  width?: number;
  // 平台标识（如 pc / ios / android）
  platform?: string;
  // 无平台图标时的占位
  platformPlaceHolder?: string;
  // 自定义平台插槽，传入后优先展示，替代 PlatformIcon
  platformSlot?: React.ReactNode;
  // 封面图是否可点击（仅用于切换鼠标指针样式）
  isOnClick?: boolean;
}

const ProjectInfo: React.FC<IProjectInfoProps> = (props) => {
  const {
    className,
    style,
    name,
    des,
    src = '',
    width = 54,
    platform,
    platformPlaceHolder,
    platformSlot,
    isOnClick,
  } = props;

  const renderPlatform = () => {
    if (platformSlot) {
      return platformSlot;
    }
    if (!platform) {
      return null;
    }
    return (
      <div className="dbs-project-info-right-info-name-platform">
        <PlatformIcon platform={platform} placeholder={platformPlaceHolder} />
      </div>
    );
  };

  return (
    <div style={style} className={classnames('dbs-project-info', className)}>
      <div className="dbs-project-info-left-img">
        <StrategicImageNew
          width={width}
          height={width}
          className={classnames('dbg-project-item-info-img', {
            'gp-cursor-pointer': isOnClick,
          })}
          src={src}
        />
      </div>
      <div className="dbs-project-info-right-info">
        <div className="dbs-project-info-right-info-name">
          <TextBubbles text={name} />
        </div>
        <div className="dbs-project-info-right-info-name-des">
          <TextBubbles text={des} />
        </div>
        {renderPlatform()}
      </div>
    </div>
  );
};

export default ProjectInfo;
